import React from "react";
import "./App.css";

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";

import { auth } from "./Login/firebase";
import LoginPage from "./Login/Login";
import Dashboard from "./Dashboard/Dashboard";
import DashboardLive from "./Dashboard/Live/DashboardLive";
import DashboardHistory from "./Dashboard/History/DashboardHistory";
import Users from "./Dashboard/Users/Users";
import Settings from "./Dashboard/Settings/Settings";
import OrderPlacement from "./Dashboard/OrderPlacement/OrderPlacement";
import StraddleDashboard from "./Dashboard/StraddleTable/StraddleDashboard";
import StrategyWise from "./Dashboard/StrategyWise/StrategyWise";
import PortfolioAnalyser from "./Dashboard/PortfolioAnalyser/portfolioAnalyser";
import SSStrategy from "./Dashboard/SSStrategy/Strategy";
import GreeksComponent from "./Dashboard/Greeks/GreeksComponent";
import StrategyFirstTable from "./Dashboard/SSStrategy/StrategyFirstTable";
import AlphaStrategy from "./Dashboard/SSStrategy/AlphaStrategy";
import PdfToExcel from "./Dashboard/PDF-toExcel/pdfToExcel";
import DataVisualizer from "./Dashboard/DataVisualizer/DataVisualizer";
import SourceTagsComponent from "./Dashboard/SourceTags/SourceTags";
import LiveMetricsDashboard from "./Dashboard/LiveMetricsDashboard";
import BotConfig from "./Dashboard/BotConfigs/BotConfig";
import StocksScreener from "./Dashboard/StocksScreener/StocksScreener";
import EventsCalendar from "./Dashboard/EventsCalendar/EventsCalendar";
import AlphaScreener from "./Dashboard/AlphaScreener/AlphaScreener";
import StockChart from "./Dashboard/Chart/new-stock";
import CommodityTrades from "./Dashboard/CommodityTrades/commodityTrades";
import RawOrdersPositions from "./Dashboard/RawOrdersPositions/RawOrdersPositions";
// import { GlobalPositionsProvider } from "./hooks/global-positions"; // REMOVED - now using GlobalDataProvider only
import { GlobalDataProvider } from "./contexts/GlobalDataContext";
import NewPositionAndOrderView from "./Dashboard/NewPositionAndOrderView/NewPositionAndOrderView.jsx";
import Audit from "./Dashboard/Audit/Audit.jsx";
import RelativeStrength from "./Dashboard/RelativeStrength/RelativeStrength.jsx";
import WebSocketInitializer from "./contexts/websocketInitializer.js";

import OpportunityScreener from "./Dashboard/OpportunityScreener/OpportunityScreener.jsx";
import ClearStocks from "./Dashboard/ClearStocks/ClearStocks.jsx";
import DeveloperAccess from "./components/DeveloperAccess";

function App(props) {
  const [user] = useAuthState(auth);
  // console.log("User form app is", user);

  const emailDomain = user ? user.email.split("@")[1] : "";

  const allowedDomains = ["iamclearmind.com", "sypto.xyz"];

  return (
    <div className="flex flex-col min-h-screen font-urbanist text-[#40414f] w-full mx-auto ">
      <GlobalDataProvider>
        <WebSocketInitializer />
        <Router>
          <Switch>
            <Route path="/relative-strength" exact>
              <RelativeStrength />
            </Route>
            <Route path="/clear-stocks" exact>
              <ClearStocks />
            </Route>
            {user && allowedDomains.includes(emailDomain) ? (
              <Switch>
                <Route path="/commodity-trades" exact>
                  <CommodityTrades />
                </Route>
                <Route path="/audit" exact>
                  <Audit />
                </Route>

                <Route path="/tv-option-chart" exact>
                  <StockChart />
                </Route>
                <Route path="/raw-orders-positions" exact>
                  <RawOrdersPositions />
                </Route>
                <Route path="/data-visualizer" exact>
                  <DataVisualizer />
                </Route>
                <Route path="/greeks" exact>
                  <GreeksComponent />
                </Route>
                <Route path="/alpha-screener" exact>
                  <AlphaScreener />
                </Route>
                <Route path="/opportunity-screener" exact>
                  <OpportunityScreener />
                </Route>
                <Route path="/events-calendar" exact>
                  <EventsCalendar />
                </Route>
                <Route path="/bot-config" exact>
                  <BotConfig />
                </Route>
                <Route path="/stocks-screener" exact>
                  <StocksScreener />
                </Route>
                <Route path="/source-tags" exact>
                  <SourceTagsComponent />
                </Route>
                <Route path="/strategy-list" exact>
                  <AlphaStrategy />
                </Route>
                <Route path="/strategy-first-table" exact>
                  <StrategyFirstTable />
                </Route>

                <Route path="/ss-strategy" exact>
                  <SSStrategy />
                </Route>
                <Route path="/portfolio-analyser" exact>
                  <PortfolioAnalyser />
                </Route>
                <Route path="/pdf-to-excel" exact>
                  <PdfToExcel />
                </Route>

                <Route path="/order-placement" exact>
                  <OrderPlacement />
                </Route>

                <Route path="/settings" exact>
                  <Settings />
                </Route>

                <Route path="/users" exact>
                  <Users />
                </Route>
                {/* <Route path="/vma" exact>
                  <VMA />
                </Route> */}
                {/* <Route path="/fyers-user-list" exact>
                  <FyersUserList />
                </Route> */}
                <Route path="/strategy-wise" exact>
                  <StrategyWise />
                </Route>
                <Route path="/straddle-table" exact>
                  <StraddleDashboard />
                </Route>
                <Route path="/history" exact>
                  <DashboardHistory />
                </Route>
                <Route path="/live-positions" exact>
                  <DashboardLive />
                </Route>
                <Route path="/live-metrics" exact>
                  <LiveMetricsDashboard />
                </Route>
                <Route path="/live-position-view" exact>
                  <NewPositionAndOrderView />
                </Route>
                <Route path="/developer_access" exact>
                  <DeveloperAccess />
                </Route>
                <Route exact path="/">
                  <Redirect to="/live-position-view" />
                </Route>
                <Route path="/dashboard">
                  <Dashboard />
                </Route>
              </Switch>
            ) : (
              <LoginPage />
            )}
          </Switch>
        </Router>
      </GlobalDataProvider>
    </div>
  );
}

export default App;
